<template>
  <qtm-menu-select
    v-bind="$attrs"
    :item-title="jobsiteName"
    :items="jobsites"
    label="Project"
    :loading="loading"
    no-filter
    searchable
    @update:search="search"
    @update:model-value="emit('update:model-value', $event)"
  >
    <template v-slot:search-hint>
      <div class="mt-3 text-center text-mid-grey">
        Start typing to see results...
      </div>
    </template>
  </qtm-menu-select>
</template>

<script setup lang="ts">
import type { Jobsite } from '@quotetome/materials-api'
import debounce from 'lodash/debounce'

export interface Props {
  company?: number
  initialId?: number | string
  limit?: number | string
  query?: Record<string, any>
}

const props = withDefaults(defineProps<Props>(), {
  company: undefined,
  initialId: undefined,
  limit: 20,
  query: undefined,
})
const emit = defineEmits(['update:initial', 'update:model-value'])

const jobsites = ref<Jobsite[]>([])
const loading = ref(false)

const jobsiteName = (jobsite?: Jobsite) => (jobsite ? `${jobsite.project_number} - ${jobsite.name}` : '')

const { $api, $error } = useNuxtApp()

const search = debounce(async (query: string) => {
  loading.value = true
  try {
    const results = await $api.v1.jobsites.list({
      ...props.query,
      company: props.company,
      limit: props.limit as number,
      offset: 0,
      search: query,
    } as any)

    jobsites.value = results.data
  }
  catch (error) {
    $error.report(error)
  }
  loading.value = false
}, 250)

onMounted(async () => {
  if (!props.initialId) {
    return
  }

  loading.value = true
  try {
    const jobsite = await $api.v1.jobsites.get(Number(props.initialId))

    emit('update:initial', jobsite)
  }
  catch (error) {
    $error.report(error)
  }
  loading.value = false
})
</script>
